import PropTypes from 'prop-types';

const allowedButtonColors = [
  'primary',
  'secondary',
  'gray',
  'enhanced',
  'danger',
  'white',
  'facebook'
];

const allowedButtonStyles = [
  'normal',
  'link',
  'button-link',
  'wrap',
  'outline'
];

const allowedButtonProps = {
  onClick(props, propName, componentName) {
    if (props.type !== 'submit' && !props[propName]) {
      return new Error(
        `Error: "onClick" property is required if button type is not "submit" - in ${
          componentName
        }`
      );
    }
  },
  type: PropTypes.oneOf(['button', 'submit']),
  buttonContent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  className: PropTypes.string,
  ariaLabel(props, propName, componentName) {
    if (!props.buttonContent && !props[propName]) {
      return new Error(
        `Error: "ariaLabel" property is required if "buttonContent" type is empty - in ${
          componentName
        }`
      );
    }
  },
  appearance: PropTypes.oneOf(allowedButtonStyles),
  buttonColor: PropTypes.oneOf(allowedButtonColors),
  ariaExpanded: PropTypes.bool,
  iconName: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  letButtonShrink: PropTypes.bool,
  sameTextAndIconColor: PropTypes.bool,
  hasSubmitButtonMargin: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  attributes: PropTypes.object,
  iconAttributes: PropTypes.object,
  pullIconRight: PropTypes.bool
};

export {
  allowedButtonProps,
  allowedButtonColors,
  allowedButtonStyles
};